import { Map } from 'immutable';
import { actionNamespace } from './defaults';

const RESET_GRID = `${actionNamespace}/RESET_GRID`;
const SORT_GRID = `${actionNamespace}/SORT_GRID`;

export default (state = Map(), { type, payload = {} }) => {
  const { gridId, values } = payload || {};
  switch (type) {
    case RESET_GRID:
      return state.set(gridId, Map());
    case SORT_GRID:
      return state.set(gridId, state.get(gridId).set('sortBy', values));
    default:
      return state;
  }
};

// columnFilters: {
//     key: 'borough',
//     selectedValues: []
//   },
//   columnTextFilter { // onclose: clear text
//     key: '',
//     text: '',
//   }

export const actionCreators = {
  resetGrid: ({ gridId }) => ({ type: RESET_GRID, payload: { gridId } }),
  sortGrid: ({ gridId, values }) => ({
    type: SORT_GRID,
    payload: { gridId, values }
  })
};



// WEBPACK FOOTER //
// ./src/state/grids-dux.js